import React, { FC } from 'react'
import { SingleSpaParcel } from './SingleSpaParcel'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { mfeConfigs } from '../../utilities/mfe'
import { FeatureDisabledResult } from '../FeatureDisabledResult'
import { LoadingAnimation } from '../LoadingAnimation'
import Helmet from 'react-helmet'
import { useAuthToken } from '../../utilities/hooks/useAuthToken'
import { useFeature } from '../../utilities/hooks/useFeature'
import { FeatureToggle } from '../../constants/FeatureToggles'
import { Routes } from '../../constants/Routes'

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const BroadcastsPage: FC<InjectedProps> = inject('currentCompanyStore')(
  observer(({ currentCompanyStore }) => {
    const canUseBroadcastsService = useFeature(
      FeatureToggle.CAN_USE_BROADCASTS_SERVICE,
      currentCompanyStore,
    )

    const authToken = useAuthToken()
    const merchantId = currentCompanyStore?.getMerchantId()
    const basename =
      currentCompanyStore &&
      currentCompanyStore.company &&
      Routes.DASHBOARD_BROADCASTS(currentCompanyStore.company.id)
    if (canUseBroadcastsService === null || !authToken || !merchantId) return <LoadingAnimation />
    return (
      <>
        <Helmet>
          <title> Reports | Broadcasts</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        {canUseBroadcastsService ? (
          <SingleSpaParcel
            basename={basename}
            authToken={authToken}
            merchantId={merchantId}
            insightsRouteKey={'broadcasts'}
            config={mfeConfigs.LOAD_INSIGHTS_PAGE}
            height={'100vh'}
          />
        ) : (
          <FeatureDisabledResult />
        )}
      </>
    )
  }),
)
